module.exports = __webpack_public_path__ + "static/img/(1960)_ContreFestival_Cologne.9d9f4ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/thumbs/(1960)_ContreFestival_Cologne.jpg
// module id = vBFj
// module chunks = 0